import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators,FormArray } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../../service/util.service';
import { UserProfile } from '../../../models/user-profile.model';
import { PromotionsService } from '../promotions.service';
import { MstPromotion } from '../../../models/mst-promotion.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../../providers/user-data';
import { RoleAccess } from '../../../models/role-access.model';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { atLeastOneDayValidator } from '../../../validators/at-least-one-day.validator';

@Component({
  selector: 'app-promotion-form',
  templateUrl: './promotion-form.page.html',
  styleUrls: ['./promotion-form.page.scss'],
})
export class PromotionFormPage implements OnInit {

  token: any;
  formPromotion!: FormGroup;
  promotionTypeData: any[] = [];
  counterList: any[] = [];
  warehouseList: any[] = [];
  userProfile: UserProfile = new UserProfile();
  //cashierType: any[] = ['Semua Kasir', 'Kasir Reguler', 'Kasir Reseller'];
  cashierType: any[] = ['Kasir Reguler'];
  maxDate: string='';
  checkedAll:boolean=false;

  roleAccess = new RoleAccess();
  warehouseId :any='';
  counterId :any='';
  selectedWarehouses:any[]=[];
  warehouseListShow:any[]=[];
  activeTierList :any[]=[];
  activeEdcList:any[]=[];

  today: string;
  selectedPromotionTypeName:string='';
  promotionId:any='0';
  action:any='';
  promotionData: any;
  countChecked:number=0;
  approval_status:number=0;
  paymentMethodList:any[]=[];
  constructor(
    private fb: FormBuilder,
    private storage: Storage,
    private utilService: UtilService,
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private promotionService: PromotionsService,
    private userData: UserData,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    const todayDate = new Date();
    const year = todayDate.getFullYear();
    const month = (todayDate.getMonth() + 1).toString().padStart(2, '0');
    const day = todayDate.getDate().toString().padStart(2, '0');
    this.today = `${year}-${month}-${day}`;
  }

  ngOnInit() {
  this.setMaxDate();
  this.buildformPromotion();

  Promise.all([
    this.storage.get('user_token'),
    this.storage.get('user_profile'),
    this.storage.get('user_menu_access')
  ]).then(([token, profile, access]) => {
    if (token) {
      this.token = token;
      this.userProfile = new UserProfile(profile);
      this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);

      if (!this.roleAccess || this.roleAccess.create != '1') {
        this.toastCtrl.create({
          duration: 2000,
          message: 'You Are Not Allowed to Access this Page'
        }).then(t => t.present());

        this.navCtrl.navigateForward(['/']);
      } else {
        this.getData();
      }
    }
  });
}

ionViewWillEnter() {
  this.formPromotion.reset();
}
setupConditionalValidation() {
  this.formPromotion.get('tipePenerima').valueChanges.subscribe(val => {
    const tipeMember = this.formPromotion.get('tipeMember');
    if (val === 'member') {
      tipeMember.setValidators([Validators.required]);
    } else {
      tipeMember.clearValidators();
      tipeMember.setValue(null);
    }
    tipeMember.updateValueAndValidity();
  });
  this.formPromotion.get('tipeMember').valueChanges.subscribe(val => {
    const tierIdList = this.formPromotion.get('tierIdList');
    if (val === 'tier_tertentu') {
      tierIdList.setValidators([Validators.required]);
    } else {
      tierIdList.clearValidators();
      tierIdList.setValue([]);
    }
    tierIdList.updateValueAndValidity();
  });
  this.formPromotion.get('paymentMethod').valueChanges.subscribe(val => {
    const paymentMethodList = this.formPromotion.get('paymentMethodList');
    if (val === 'specific') {
      paymentMethodList.setValidators([Validators.required]);
    } else {
      paymentMethodList.clearValidators();
      paymentMethodList.setValue([]);
    }
    paymentMethodList.updateValueAndValidity();
  });
  this.formPromotion.get('edcType').valueChanges.subscribe(val => {
    const edcIdList = this.formPromotion.get('edcIdList');
    if (val === 'specific') {
      edcIdList.setValidators([Validators.required]);
    } else {
      edcIdList.clearValidators();
      edcIdList.setValue([]);
    }
    edcIdList.updateValueAndValidity();
  });
}

  buildformPromotion() {
    this.formPromotion = this.fb.group({
      counterId: [null, Validators.required],
      warehouseId: [null, Validators.required],
      promotionName: [null, Validators.required],
      earlyPeriod: [null, Validators.required],
      endPeriod: [null, Validators.required],
      promotionType: [null, Validators.required],
      promotionCashierType: [1, Validators.required],
      validOnSun: [false],
      validOnMon: [false],
      validOnTue: [false],
      validOnWed: [false],
      validOnThu: [false],
      validOnFri: [false],
      validOnSat: [false],
      tipePenerima:[null],
      tipeMember:[],
      tierIdList:[],
      paymentMethod : [],
      paymentMethodList : [[]],
      edcType:[null],
      edcIdList:[]
    }, {
      validators: atLeastOneDayValidator
    });
    
    this.formPromotion.get('earlyPeriod')!.valueChanges.subscribe((start) => {
      const endDateControl = this.formPromotion.get('endPeriod');
      const end = endDateControl!.value;
      if (start && end && new Date(start) > new Date(end)) {
        endDateControl!.setValue(null);
      }
    });
    
    this.formPromotion.get('promotionType')!.valueChanges.subscribe(val => {
      const selected = this.promotionTypeData.find(x => x.id == val);
      this.selectedPromotionTypeName = selected?selected.promotion_type_name : '';
    });
    this.formPromotion.get('paymentMethodList')!.valueChanges.subscribe(val => {
      if (!val || val.length === 0) {
        this.formPromotion.patchValue({
          edcType: 'all',
          edcIdList: []
        });
      }
    });
    this.setupConditionalValidation();
  }
  
  getData(){    
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.action = JSON.parse(
        AES.decrypt(snapshot.a, myKey).toString(utf8)
      );
      this.promotionId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      if(this.action=='A'){
        this.utilService.loadingPresent('Harap tunggu...l')
        .then(() => {
          let options = {
            "token": this.token,
            "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
          };
          this.promotionService.getPromotionforCreate(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.promotionTypeData = response.results.promotion_type_data;
            this.counterList = response.results.counter_data;
            this.warehouseList = response.results.warehouse_data;
            this.warehouseListShow = this.warehouseList;
            this.activeTierList = response.results.tier;
            this.activeEdcList = response.results.edc;
            this.paymentMethodList = response.results.payment_method_list;
            this.paymentMethodList = this.paymentMethodList.map(pm => ({
              ...pm,
              payment_label: `${pm.payment_type_name} - ${pm.payment_name}`
            }));
          });
        });
      }
      else if(this.action=='U'){
        this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        let options = {
          "token": this.token,
          "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
        };
        this.promotionService.getPromotionforEdit(this.promotionId, options).subscribe((response) => {
          this.utilService.loadingDismiss();
          this.promotionData = response.results.data;
          this.promotionTypeData = response.results.promotion_type_data;
          this.counterList = response.results.counter_data;
          this.warehouseList = response.results.warehouse_data;
          this.activeTierList = response.results.tier;
          this.activeEdcList = response.results.edc;
          this.paymentMethodList = response.results.payment_method_list;
          this.paymentMethodList = this.paymentMethodList.map(pm => ({
            ...pm,
            payment_label: `${pm.payment_type_name} - ${pm.payment_name}`
          }));

          let validOnSun: any = false, validOnMon: any = false, validOnTue: any = false, validOnWed: any = false,
          validOnThu: any = false, validOnFri: any = false, validOnSat: any = false;

          if(this.promotionData.valid_on_su === '1') { validOnSun = true; this.countChecked++; };
          if(this.promotionData.valid_on_mo === '1') { validOnMon = true; this.countChecked++; };
          if(this.promotionData.valid_on_tu === '1') { validOnTue = true; this.countChecked++; };
          if(this.promotionData.valid_on_we === '1') { validOnWed = true; this.countChecked++; };
          if(this.promotionData.valid_on_th === '1') { validOnThu = true; this.countChecked++; };
          if(this.promotionData.valid_on_fr === '1') { validOnFri = true; this.countChecked++; };
          if(this.promotionData.valid_on_sa === '1') { validOnSat = true; this.countChecked++; };
          if(this.countChecked==7){
            this.checkedAll = true;
          }
          this.approval_status = this.promotionData.approval_status;
          
          let counterIdSplit = this.promotionData.counter_id !== '' ? String(this.promotionData.counter_id).split(',') : [];
          let selectedCounterx = [];
          if(counterIdSplit.length>0){
            for(let i= 0; i < counterIdSplit.length; i++) {        
              let selectedCounter: any = this.counterList.find(x => x.id ==  parseInt(counterIdSplit[i]));
              if(selectedCounter){
                selectedCounterx.push(selectedCounter)      
              }
            }
          }
          let selectedWarehousex = [];
          let warehouseIdSplit = this.promotionData.warehouse_id !== '' ? String(this.promotionData.warehouse_id).split(',') : [];
          if(warehouseIdSplit.length>0){
            for(let i= 0; i < warehouseIdSplit.length; i++) {        
              let selectedWarehouse: any = this.warehouseList.find(x => x.id ==  parseInt(warehouseIdSplit[i]));
              if(selectedWarehouse){
                selectedWarehousex.push(selectedWarehouse)      
              }
            }
          }
          let selectedTierId = [];
          let tierIdList = this.promotionData.tier_id_list !== '' ? String(this.promotionData.tier_id_list).split(',') : [];
          if(tierIdList.length>0){
            for(let i= 0; i < tierIdList.length; i++) {        
              let selectedTier: any = this.activeTierList.find(x => x.id ==  parseInt(tierIdList[i]));
              if(selectedTier){
                selectedTierId.push(selectedTier)      
              }
            }
          }
          let selectedEdcId = [];
          let edcIdList = this.promotionData.edc_id_list !== '' ? String(this.promotionData.edc_id_list).split(',') : [];
          if(edcIdList.length>0){
            for(let i= 0; i < edcIdList.length; i++) {        
              let selectedEdc: any = this.activeEdcList.find(x => x.id ==  parseInt(edcIdList[i]));
              if(selectedEdc){
                selectedEdcId.push(selectedEdc)      
              }
            }
          }

          const selectedIds = this.promotionData.payment_method_list;
          let selectedPayment = this.paymentMethodList.filter(pm =>
            selectedIds.includes(pm.id.toString())
          );
          this.formPromotion.patchValue({
            counterId: selectedCounterx,
            warehouseId: selectedWarehousex,
            promotionName: this.promotionData.promotion_name,
            earlyPeriod: this.promotionData.early_period,
            endPeriod: this.promotionData.end_period,
            promotionType: parseInt(this.promotionData.promotion_type_id), 
            promotionCashierType: parseInt(this.promotionData.promotion_cashier_type), 
            validOnSun: validOnSun,
            validOnMon: validOnMon,
            validOnTue: validOnTue,
            validOnWed: validOnWed,
            validOnThu: validOnThu,
            validOnFri: validOnFri,
            validOnSat: validOnSat,
            checkedAll : this.checkedAll,
            activeStatus: parseInt(this.promotionData.status),
            tipePenerima: this.promotionData.tipe_penerima,
            tipeMember: this.promotionData.tipe_member,
            tierIdList: selectedTierId,
            edcType: this.promotionData.edc_type,
            edcIdList: selectedEdcId,
            paymentMethod: this.promotionData.payment_method,
            paymentMethodList: selectedPayment
          })
          const counterControl = this.formPromotion.get('counterId');
          if (counterControl) {
            counterControl.disable();
          }

          const warehouseControl = this.formPromotion.get('warehouseId');
          if (warehouseControl) {
            warehouseControl.disable();
          }
          this.formPromotion.get('earlyPeriod')!.valueChanges.subscribe((start) => {
            const endDateControl = this.formPromotion.get('endPeriod');
            const end = endDateControl!.value;
            if (start && end && new Date(start) > new Date(end)) {
              endDateControl!.setValue(null);
            }
          });
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        });
      });
      }
    });
  }
  submitForm() {
    if (this.formPromotion.invalid) {
      this.formPromotion.markAllAsTouched();

      const fieldLabels = {
        paymentMethodList: 'Debit / Kredit',
        tierIdList: 'Tier',
        counterId: 'Counter',
        warehouseId: 'Gudang',
        promotionName: 'Nama Promosi',
        earlyPeriod:'Tanggal Mulai',
        endPeriod:'Tanggal Selesai',
        promotionType:'Tipe Promosi',
        promotionCashierType:'Tipe Kasir',
        tipeMember:'Tipe Member',
        tipePenerima:'Tipe Penerima',
        edcIdList:'EDC'
      };

      const invalidFields = Object.keys(this.formPromotion.controls)
        .filter(key =>
          this.formPromotion.get(key) &&
          this.formPromotion.get(key).invalid
        )
        .map(key => fieldLabels[key] || key);

      if (
        this.formPromotion.errors &&
        this.formPromotion.errors.atLeastOneDay
      ) {
        invalidFields.push(fieldLabels['validOnDays']);
      }
      const fieldText = invalidFields.join(', ').replace(/,([^,]*)$/, '.$1');
      this.toastCtrl.create({
        message: 'Lengkapi field wajib terlebih dahulu.'+fieldText,
        duration: 2000,
        color: 'danger'
      }).then(t => t.present());
      return;
    }
    this.inputPromotions();
  }
  inputPromotions() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const promotionData = this.formPromotion.getRawValue();
      let paymentMethodList = promotionData.paymentMethodList
      ? promotionData.paymentMethodList.map((x: any) => x.id)
      : []
      let earlyPeriods = this.utilService.convertDate(promotionData.earlyPeriod);
      let endPeriods = this.utilService.convertDate(promotionData.endPeriod);
      let newEarlyPeriod = earlyPeriods.years + '-' + earlyPeriods.months + '-' + earlyPeriods.dates;
      let newEndPeriod = endPeriods.years + '-' + endPeriods.months + '-' + endPeriods.dates;
      let tipePenerima = promotionData.tipePenerima ? promotionData.tipePenerima : 'umum';
      let tipeMember = promotionData.tipeMember ? promotionData.tipeMember: '';
      let paymentMethod = promotionData.paymentMethod ?  promotionData.paymentMethod : 'all';
      let tierIdList = promotionData.tierIdList ?  promotionData.tierIdList : '';
      let edcType = promotionData.edcType ? promotionData.edcType : 'all';
      let edcIdList = promotionData.edcIdList ? promotionData.edcIdList : 0;
      let listTierId='';
      if(tierIdList.length > 0) {
        for(let i = 0; i < tierIdList.length; i++) {
          listTierId = listTierId + tierIdList[i].id;
          if((i+1) !== tierIdList.length) {
            listTierId = listTierId + ',';
          }
        }
      }let listEdcId='';
      if(edcIdList.length > 0) {
        for(let i = 0; i < edcIdList.length; i++) {
          listEdcId = listEdcId + edcIdList[i].id;
          if((i+1) !== edcIdList.length) {
            listEdcId = listEdcId + ',';
          }
        }
      }
      let validOnSun: any = '0', validOnMon: any = '0', validOnTue: any = '0', 
      validOnWed: any = '0', validOnThu: any = '0', validOnFri: any = '0', validOnSat: any = '0';

      if(promotionData.validOnSun === true) { validOnSun = '1'; };
      if(promotionData.validOnMon === true) { validOnMon = '1'; };
      if(promotionData.validOnTue === true) { validOnTue = '1'; };
      if(promotionData.validOnWed === true) { validOnWed = '1'; };
      if(promotionData.validOnThu === true) { validOnThu = '1'; };
      if(promotionData.validOnFri === true) { validOnFri = '1'; };
      if(promotionData.validOnSat === true) { validOnSat = '1'; };
      let counterList ='';
      let whList='';
      if(this.action=='A'){
        this.counterId = this.counterId.sort((a: number, b: number) => a - b);
        for(let i=0;i<this.counterId.length;i++){
          counterList+=this.counterId[i]+',';
        }
        for(let i=0;i<this.warehouseId.length;i++){
          whList+=this.warehouseId[i]+',';
        }
      }
      const mstPromotion = new MstPromotion();
      mstPromotion.counter_id = counterList;
      mstPromotion.warehouse_id = whList;
      mstPromotion.promotion_name = promotionData.promotionName;
      mstPromotion.early_period = newEarlyPeriod;
      mstPromotion.end_period = newEndPeriod;
      mstPromotion.promotion_type_id = promotionData.promotionType;
      mstPromotion.promotion_cashier_type = String(promotionData.promotionCashierType);
      mstPromotion.valid_on_su = validOnSun;
      mstPromotion.valid_on_mo = validOnMon;
      mstPromotion.valid_on_tu = validOnTue;
      mstPromotion.valid_on_we = validOnWed;
      mstPromotion.valid_on_th = validOnThu;
      mstPromotion.valid_on_fr = validOnFri;
      mstPromotion.valid_on_sa = validOnSat;
      mstPromotion.tipe_penerima = tipePenerima;
      mstPromotion.tipe_member = tipeMember;
      mstPromotion.tier_id_list = listTierId;
      mstPromotion.edc_type = edcType;
      mstPromotion.edc_id_list = listEdcId;
      mstPromotion.created_by = this.userProfile.username;
      mstPromotion.updated_by = this.userProfile.username;
      mstPromotion.payment_method = paymentMethod;
      mstPromotion.payment_method_list = paymentMethodList;
      if(this.action=='A'){
        this.promotionService.addPromotion(mstPromotion).subscribe((response) => {
          this.utilService.loadingDismiss();
          if(response.status.code === 200) {
            this.showConfirmInput();
          }
          else  if(response.status.code === 222) {
            this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
          } else {
            this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
          }
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        })
      }
      else if(this.action=='U'){
        this.promotionService.updatePromotion(this.promotionId, mstPromotion).subscribe((response) => {
          this.utilService.loadingDismiss();
          if(response.status.code === 200) {
            this.showConfirmInput();
          }
          else  if(response.status.code === 222) {
            this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
          } else {
            this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
          }
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        })
      }
    });
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/promotions']);;
          }
        }
      ]
    });

    await alert.present();
  }

  uncheckAll(ev: any) {
    this.checkedAll = ev.detail.checked;

    this.formPromotion.patchValue({
      validOnSun: this.checkedAll,
      validOnMon: this.checkedAll,
      validOnTue: this.checkedAll,
      validOnWed: this.checkedAll,
      validOnThu: this.checkedAll,
      validOnFri: this.checkedAll,
      validOnSat: this.checkedAll
    });
  }
  selectWarehouse(event:any){
    this.warehouseId = [];
    for(let i= 0; i < event.value.length; i++) {   
      this.warehouseId.push(event.value[i]['id']);
    }
  }

  selectCounter(event:any){
    this.counterId = [];
    this.warehouseId ='';
    this.selectedWarehouses=[];
    this.warehouseListShow=[];
    let wh =[];
    for(let i= 0; i < event.value.length; i++) {
      this.counterId.push(event.value[i]['id']);
      wh[i]=(this.warehouseList.filter(x => parseInt(x.counter_id) === parseInt( event.value[i]['id'])));
    }
    let a=0;
    for(let i=0;i<wh.length;i++){
      for(let j=0;j<wh[i].length;j++){
        this.warehouseListShow[a]=wh[i][j];
        a++;
      }
    }
  }

  setMaxDate() {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    // Set the max date to the last day of next year (31 Dec)
    this.maxDate = `${nextYear}-12-31`;
  }
}